import React from 'react';

import {
  hamburgerMenu,
  hamburgerMenuContainer,
  allMenuContainer,
} from './scss/HamburgerMenu.module.scss';

const HamburgerMenu = () => {
  return (
    <div className={allMenuContainer}>
      <div className={hamburgerMenuContainer}>
        <div className={hamburgerMenu}>
          <i />
        </div>
      </div>
    </div>
  );
};

export default HamburgerMenu;
